import React from 'react';

/** 云 RBP「打印」壳内「辅助模式」：开启后各子页展示参数说明、列表副标题等 */
export type PrintModuleAuxiliaryModeContextValue = {
    auxiliaryModeEnabled: boolean;
    setAuxiliaryModeEnabled: (enabled: boolean) => void;
};

const defaultValue: PrintModuleAuxiliaryModeContextValue = {
    auxiliaryModeEnabled: false,
    setAuxiliaryModeEnabled: () => {},
};

export const PrintModuleAuxiliaryModeContext =
    React.createContext<PrintModuleAuxiliaryModeContextValue>(defaultValue);
